import styled from 'styled-components';

const StyledContainer = styled.div`
	position: relative;
	z-index: 2;
	width: 460px;
	padding: 60px 0 0 60px;
`;

const StyledMarginContainer = styled.div`
	margin-top: 30px;
`;

const StyledControlsContainer = styled.div`
	display: flex;
	justify-content: space-between;
	position: absolute;
	left: 80px;
	right: 80px;
	bottom: 80px;
`;

const StyledRightContainer = styled.div`
	position: absolute;
	top: 80px;
	right: 80px;
	display: flex;
	gap: 40px;
`;

export {
	StyledContainer,
	StyledControlsContainer,
	StyledMarginContainer,
	StyledRightContainer,
};
